import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';
import { ADMIN_TYPES } from '../../constants/Systems';

const Dealer = () => {
  const match = useRouteMatch();
  const { authUser } = useSelector(({ auth }) => auth);

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        {authUser && ADMIN_TYPES.includes(authUser.type) && (
          <React.Fragment>
            <Route exact path={`${match.url}`} component={lazy(() => import('./Dealer'))} />
            <Route path={`${match.url}/add`} component={lazy(() => import('./DealerEdit'))} />
            <Route path={`${match.url}/edit/:id`} component={lazy(() => import('./DealerEdit'))} />
          </React.Fragment>
        )}

        <Route component={lazy(() => import('../error/Error404'))} />
      </Switch>
    </Suspense>
  );
};

export default Dealer;
